import React from 'react'
import { useNavigate } from 'react-router-dom'
import { generatePublicUrl } from '../../urlConfig'
import activeAddButton from '../../containers/Products/ActiveAddButton'
import ZoomIcon from '../Icon/ZoomIcon'
import FavoriteIconComponent from '../Icon/FavoriteIconComponent'
import MoreIconFunctionalityProduct from '../Search/MoreIconFunctionalityProduct'

const ItemGallery = ({
    localStorageLiked,
    item,
    handleClick,
    contentItemType,
    addGalleryImgUser,
    galleryImagesUser,
    authenticate,
    handleMouseClose,
    handleShowButton,
    currentId,
}) => {
    const navigate = useNavigate()

    const image = item?.picture?.img || item?.img || ''
    const imageId = item?._id || item?.picture?._id || image
    const productId = item?.productId || item?.product?._id || item?.product || item?._id || ''
    const imageAlt = item?.fullName || item?.name || item?.picture?.name || imageId || 'Фото продукции'
    const isActive = imageId === currentId

    const productActionItem = {
        ...item,
        _id: productId,
        productId,
        img: item?.reducedImage || item?.img || item?.picture?.img || item?.mainImage || '',
        reducedImage: item?.reducedImage || item?.picture?.img || item?.img || '',
        mainImage: item?.mainImage || item?.picture?.img || item?.img || '',
        fullName: item?.fullName || item?.name || item?.picture?.name || 'Товар',
    }

    const handleGoToProduct = (event) => {
        event.stopPropagation()

        if (!productId) {
            return
        }

        navigate(`/productDetails/${productId}`)
        window.scrollTo(0, 0)
    }

    const renderImage = () => {
        if (!image) {
            return (
                <div className="itemGallery__emptyImage">
                    Нет фото
                </div>
            )
        }

        return (
            <img
                className="itemGallery__image"
                src={generatePublicUrl(image)}
                alt={imageAlt}
                loading="lazy"
            />
        )
    }

    const renderContent = () => {
        switch (contentItemType) {
            case 'mainPages':
                return (
                    <>
                        <FavoriteIconComponent
                            item={item}
                            addGalleryImgUser={addGalleryImgUser}
                            galleryImagesUser={authenticate ? galleryImagesUser?.galleryImgUserItems : localStorageLiked}
                            activeAddButton={activeAddButton}
                        />

                        <ZoomIcon
                            item={item}
                            currentId={currentId}
                            handleClick={handleClick}
                        />

                        {renderImage()}
                    </>
                )

            default:
                return (
                    <div className="itemGallery__galleryPage">
                        {renderImage()}

                        <div className="itemGallery__actions">
                            <ZoomIcon
                                item={item}
                                currentId={currentId}
                                handleClick={handleClick}
                            />

                            {productId ? (
                                <button
                                    type="button"
                                    className="itemGallery__productButton"
                                    onClick={handleGoToProduct}
                                >
                                    <span>К товару</span>
                                </button>
                            ) : null}

                            <div className="itemGallery__moreIcon">
                                <MoreIconFunctionalityProduct obj={productActionItem} />
                            </div>
                        </div>
                    </div>
                )
        }
    }

    return (
        <div
            className={`itemGallery ${isActive ? 'active' : ''}`}
            onMouseEnter={() => handleShowButton(imageId)}
            onClick={() => handleShowButton(imageId)}
            onMouseLeave={() => handleMouseClose()}
        >
            {renderContent()}
        </div>
    )
}

export default ItemGallery